<div class="reconciled-detail-panel" fxLayout="column" *ngIf="reconciledDetail">
  <div class="reconciled-detail-panel__header h-112 px-24" fxFlex fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <div class="font-size-24">
        <span class="artstuff-orange-fg text-bold">{{ 'PANEL_TITLE' | translate }} </span>
        <span class="artstuff-promt-text ml-16 text-bold">{{ reconciledDetail.ticketId }}</span>
      </div>
      <div
        class="text-bold artstuff-title-form-text mt-8"
        [ngClass]="{
          'amber-600-fg': reconciledDetail.status === TICKET_STATUS_ENUM.WAITINGAPPROVAL,
          'green-500-fg': reconciledDetail.status === TICKET_STATUS_ENUM.COMPLETED,
          'artstuff-warning-color': reconciledDetail.status === TICKET_STATUS_ENUM.REQUESTMODIFICATION,
          'artstuff-content-600-color': reconciledDetail.status === TICKET_STATUS_ENUM.PENDING
        }"
      >
        {{ 'TICKET_STATUS.' + reconciledDetail.status | translate }}
      </div>
      <div class="artstuff-title-form-text">{{ 'RECONCILE_STATUS.' + reconciledDetail.reconcileStatus | translate }}</div>
    </div>

    <button mat-icon-button class="close-button" (click)="closeView()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="reconciled-detail-panel__content" fxFlex fxLayout="row" fxLayoutAlign="start">
    <div class="reconciled-detail-panel__content-left" fxFlex fxLayout="column" fxFill>
      <div class="summary-info-section" fxLayout="column">
        <!-- Header -->
        <div
          class="summary-info-section__header h-56 pl-24 text-bold artstuff-orange-fg"
          fxLayout="row"
          fxLayoutAlign="space-between center"
        >
          <div fxFlex="33">{{ 'SUMMARY_INFO.CUSTOMER_INFO' | translate }}</div>
          <div fxFlex="33">{{ 'SUMMARY_INFO.ORDER_INFO' | translate }}</div>
          <div fxFlex="34">{{ 'SUMMARY_INFO.TRANSACTION_INFO' | translate }}</div>
        </div>
        <!-- Content -->
        <div class="summary-info-section__detail pl-24" fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div class="info-data pt-28" fxFlex="33">
              <div class="info-data__header">{{ 'SUMMARY_INFO.CONTACT' | translate }}</div>
              <div class="info-data__detail">
                <ng-template [ngIf]="reconciledDetail.orderInfo?.customerInfo" [ngIfElse]="noContact">
                  {{ reconciledDetail.orderInfo?.customerInfo?.firstName + ' ' + reconciledDetail.orderInfo?.customerInfo?.lastName }}<br />
                  {{ reconciledDetail.orderInfo?.customerInfo?.email }}<br />
                  {{ reconciledDetail.orderInfo?.customerInfo?.phone }}<br />
                </ng-template>
                <ng-template #noContact>{{ this.emptyValue }}</ng-template>
              </div>
            </div>
            <div class="info-data pt-28" fxFlex="33">
              <div>
                <div class="info-data__header">{{ 'SUMMARY_INFO.TRANSACTION_ID' | translate }}</div>
                <div class="info-data__detail text-bold">
                    <span #orderInfoTransactionId>{{ reconciledDetail.orderInfo?.transactionId || this.emptyValue }}</span>
                    <mat-icon *ngIf="reconciledDetail.orderInfo && reconciledDetail.orderInfo.transactionId" svgIcon="artstuff_icon_copy" class="s-20" style="vertical-align: middle; cursor: pointer; margin-left: 5px;" (click)="copyToClipboard(orderInfoTransactionId)"></mat-icon>
                </div>
              </div>
              <div class="mt-6 mr-32">
                <div class="info-data__header">{{ 'SUMMARY_INFO.ORDER_ID' | translate }}</div>
                <div class="info-data__detail text-bold">{{ reconciledDetail.orderInfo?.orderCode || this.emptyValue }}</div>
              </div>
            </div>
            <div class="info-data pt-28" fxFlex="34">
              <div>
                <div class="info-data__header">{{ 'SUMMARY_INFO.EXTERNAL_REFERENCE_NO' | translate }}</div>
                <div class="info-data__detail text-bold">
                    <span #invoice>{{ reconciledDetail.paymentInfo?.invoice || this.emptyValue }}</span>
                    <mat-icon *ngIf="reconciledDetail.paymentInfo && reconciledDetail.paymentInfo.invoice" svgIcon="artstuff_icon_copy" class="s-20" style="vertical-align: middle; cursor: pointer; margin-left: 5px;" (click)="copyToClipboard(invoice)"></mat-icon>
                </div>
              </div>
              <div class="mt-6 mr-32">
                <div class="info-data__header">{{ 'SUMMARY_INFO.REFERENCE_TXN_ID' | translate }}</div>
                <div class="info-data__detail text-bold">
                    <span #referenceTxnId>{{ reconciledDetail.paymentInfo?.refTxnId || this.emptyValue }}</span>
                    <mat-icon *ngIf="reconciledDetail.paymentInfo && reconciledDetail.paymentInfo.refTxnId" svgIcon="artstuff_icon_copy" class="s-20" style="vertical-align: middle; cursor: pointer; margin-left: 5px;" (click)="copyToClipboard(referenceTxnId)"></mat-icon>
                </div>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="row" fxFlex="33">
              <div class="info-data">
                <div class="info-data__header">{{ 'SUMMARY_INFO.SHIPPING_ADDRESS' | translate }}</div>
                <div class="info-data__detail">{{ shippingAddress }}</div>
              </div>
            </div>
            <div fxLayout="row" fxFlex="33">
              <div class="info-data">
                <div class="info-data__header">{{ 'SUMMARY_INFO.ORDER_DATE' | translate }}</div>
                <div class="info-data__detail">
                  {{ (reconciledDetail.orderInfo?.orderDate | date: 'dd/MM/YYYY') || this.emptyValue }}
                </div>
              </div>
            </div>
            <div class="info-data" fxFlex="34">
              <div class="info-data__header">{{ 'SUMMARY_INFO.DATE' | translate }}</div>
              <div class="info-data__detail">
                {{ (reconciledDetail.paymentInfo?.date | date: 'dd/MM/YYYY') || reconciledDetail.paymentInfo?.dateString || this.emptyValue }}
              </div>
            </div>
          </div>

          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div class="info-data" fxFlex="33">
              <div class="info-data__header">{{ 'SUMMARY_INFO.EMAIL_FOR_CHECKOUT' | translate }}</div>
              <div class="info-data__detail">{{ stringOrNull(reconciledDetail.paymentInfo?.fromEmail) || this.emptyValue }}</div>
            </div>
            <div class="info-data" fxFlex="33">
              <div class="info-data__header">{{ 'SUMMARY_INFO.ITEM' | translate }}</div>
              <span *ngIf="!reconciledDetail.orderInfo?.orderItems.length; else orderItems">--</span>
              <ng-template #orderItems>
                <div class="order-items mb-16" *ngFor="let item of reconciledDetail.orderInfo?.orderItems">
                  <div class="info-data__detail">{{ item.name }} x{{ item.quantity }}</div>
                  <div class="info-data__attribute" *ngIf="item.customAttributes.AMS_IS_GIFT_PRODUCT">{{ 'SUMMARY_INFO.GIFT' | translate }}</div>
                  <div class="info-data__attribute" *ngIf="item.customAttributes.AMS_BUNDLE_NAME != null">{{ 'SUMMARY_INFO.BUNDLE_NAME' | translate }}: {{ item.customAttributes.AMS_BUNDLE_NAME }}</div>
                  <div class="info-data__attribute">{{ 'SUMMARY_INFO.SKU' | translate }}: {{ item.sku || this.emptyValue }}</div>
                  <div class="info-data__attribute" *ngFor="let attribute of item.orderAttributes">
                    <span *ngIf="attribute.name.trim() || attribute.option.trim()" class="mr-5">
                      {{ (attribute.name.trim() || this.emptyValue) | titlecase }}: {{ (attribute.option.trim() || this.emptyValue) | titlecase }}
                    </span>
                  </div>
                  <div class="info-data__attribute">{{ item.unitPrice | currency }}</div>
                </div>
              </ng-template>
            </div>
            <div class="info-data" fxFlex="34">
              <div class="info-data__header">{{ 'SUMMARY_INFO.ITEM' | translate }}</div>
              <span *ngIf="!reconciledDetail.paymentInfo?.items.length; else paidOrderItems">--</span>
              <ng-template #paidOrderItems>
                <div class="order-items mb-16" *ngFor="let item of reconciledDetail.paymentInfo?.items">
                  <div class="info-data__detail">{{ item.name }} x{{ item.quantity }}</div>
                  <div class="info-data__attribute">{{ item.unitPrice | currency }}</div>
                </div>
              </ng-template>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between start">
            <div fxFlex="33"></div>
            <div fxFlex="33"></div>
            <div class="info-data" fxFlex="34">
              <div class="info-data__header">{{ 'SUMMARY_INFO.TYPE' | translate }}</div>
              <div class="info-data__detail">{{ reconciledDetail.paymentInfo?.type || this.emptyValue }}</div>
            </div>
          </div>
          <div class="pb-24" fxLayout="row" fxLayoutAlign="space-between start">
            <div fxFlex="33"></div>
            <div fxFlex="33"></div>
            <div class="info-data" fxFlex="34">
              <div class="info-data__header">{{ 'SUMMARY_INFO.PAYMENT_METHOD' | translate }}</div>
              <div class="info-data__detail">
                {{
                  (reconciledDetail.paymentInfo?.gateway &&
                    ('SUMMARY_INFO.PAYMENT_METHOD_TYPE.' + reconciledDetail.paymentInfo?.gateway | translate)) ||
                    this.emptyValue
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="reconciliation-results-section mt-16" fxFlex="256px" fxLayout="column">
        <!-- Header -->
        <div
          class="reconciliation-results-section__header h-56 pl-24 text-bold artstuff-orange-fg"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          {{ 'RECONCILIATION_RESULTS.TITLE' | translate }}
        </div>

        <!-- Detail -->
        <div class="reconciliation-results-section__detail" fxLayout="row">
          <div fxFlex="50" class="reconciliation-results-section__detail-order p-24">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <span fxLayout="row" fxLayoutAlign="center center">
                <span class="detail-summary-title">{{ 'RECONCILIATION_RESULTS.ORDER_SUMMARY' | translate }}</span>
                <span class="reconciliation-results__detail">{{ 'RECONCILIATION_RESULTS.TOTAL_PAID' | translate | titlecase }}</span>
              </span>
              <span
                class="reconciliation-results__value"
                [ngClass]="{
                  'reconciliation-results__value__processed':
                    reconciledDetail.status === TICKET_STATUS_ENUM.COMPLETED &&
                    reconciledDetail.reconcileStatus === RECONCILE_STATUS_ENUM.RECONCILED
                }"
                >{{ (reconciledDetail.orderInfo?.total | currency) || this.emptyValue }}</span
              >
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-16">
              <span class="info-data__header">{{ 'RECONCILIATION_RESULTS.TOTAL_PAYMENT' | translate }}</span>
              <span class="reconciliation-results__detail">{{ (totalPayment | currency) || this.emptyValue }}</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-8">
              <div class="">
                <div class="info-data__header">{{ 'RECONCILIATION_RESULTS.SHIPPING_COST' | translate }}</div>
                <div class="info-data__attribute">{{ reconciledDetail.orderInfo?.shippingMethod }}</div>
              </div>
              <div class="reconciliation-results__detail">
                {{ (reconciledDetail.orderInfo?.shippingFee | currency) || this.emptyValue }}
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-8 pb-8">
              <div class="">
                <div class="info-data__header">{{ 'RECONCILIATION_RESULTS.DISCOUNT' | translate }}</div>
                <div class="info-data__attribute">{{ reconciledDetail.orderInfo?.discountCode }}</div>
              </div>
              <div class="reconciliation-results__detail" [ngClass]="{ 'prefix--minus': reconciledDetail.orderInfo?.discountFee > 0 }">
                {{ (reconciledDetail.orderInfo?.discountFee | currency) || this.emptyValue }}
              </div>
            </div>
          </div>
          <div fxFlex="50" class="p-24">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <span fxLayout="row" fxLayoutAlign="center center">
                <span class="detail-summary-title">{{ 'RECONCILIATION_RESULTS.INVOICE_SUMMARY' | translate }}</span>
                <span class="reconciliation-results__detail">{{ 'RECONCILIATION_RESULTS.TOTAL_PAID' | translate | titlecase }}</span>
              </span>
              <span
                class="reconciliation-results__value"
                [ngClass]="{
                  'reconciliation-results__value__processed':
                    reconciledDetail.status === TICKET_STATUS_ENUM.COMPLETED &&
                    reconciledDetail.reconcileStatus === RECONCILE_STATUS_ENUM.RECONCILED
                }"
                >{{ (reconciledDetail.paymentInfo?.grossAmount | currency) || this.emptyValue }}</span
              >
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-16">
              <span class="info-data__header">{{ 'RECONCILIATION_RESULTS.AMOUNT' | translate }}</span>
              <span class="reconciliation-results__detail">{{
                (reconciledDetail.paymentInfo?.grossAmount | currency) || this.emptyValue
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="working-history-section mt-16" fxLayout="column">
        <!-- Header -->
        <div class="working-history-section__header h-56 pl-24 text-bold artstuff-orange-fg" fxLayout="row" fxLayoutAlign="start center">
          {{ 'WORKING_HISTORY.TITLE' | translate }}
        </div>

        <!-- Detail -->
        <div class="working-history-section__detail pl-24 mb-8" fxLayout="column">
          <div fxLayout="row" class="mt-12 mb-8">
            <span class="info-data__header w-30-p">{{ 'WORKING_HISTORY.TIME' | translate }}</span>
            <span class="info-data__header">{{ 'WORKING_HISTORY.CONTENT' | translate }}</span>
          </div>
          <div
            class="mb-4"
            fxLayout="row"
            *ngFor="let reconcileLog of reconciledDetail.activityLogs; first as isFirst"
            [ngClass]="isFirst ? 'first-reconcileLog-text' : 'artstuff-promt-text'"
          >
            <span class="w-30-p">{{ reconcileLog.activityDate | date: 'HH:mm dd/MM/YYYY' }}</span>
            <span class="w-70-p">{{ reconcileLog.contents[lang] }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="reconciled-detail-panel__content-right ml-32 h-100-p" fxLayout="column" fxFlex="30">
      <div class="confirmation-section">
        <!-- Header -->
        <div class="confirmation-section__header h-56 pl-24 text-bold artstuff-orange-fg" fxLayout="row" fxLayoutAlign="start center">
          {{ 'CONFIRMATION.TITLE' | translate }}
        </div>

        <!-- Detail -->
        <div class="confirmation-section__detail p-16 pb-8" fxLayout="column" fxLayoutAlign="end end" [formGroup]="confirmationForm">
          <mat-form-field appearance="outline" class="w-100-p">
            <mat-label>{{ 'CONFIRMATION.SELECT_LABEL' | translate }}</mat-label>
            <mat-select
              disableOptionCentering="true"
              panelClass="confirmation-section__select"
              formControlName="selectReason"
              [required]="!isMakerViewMode() && ability.includes(PORTAL_AUTHORITY_ENUM.PERM_CONFIRM_SALE_DATA)"
            >
              <mat-option
                *ngFor="let reason of confirmationReasonList"
                [value]="reason.code"
                [disabled]="isMakerViewMode() || !ability.includes(PORTAL_AUTHORITY_ENUM.PERM_CONFIRM_SALE_DATA)"
              >
                {{ 'CONFIRMATION.REASON.' + reason.code | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="w-100-p" *ngIf="confirmationForm.get('selectReason').value">
            <mat-form-field appearance="outline" class="w-100-p">
              <mat-label *ngIf="!showDescriptionTxt">{{ 'CONFIRMATION.REFERENCE_TXN_ID' | translate }}</mat-label>
              <mat-label *ngIf="showDescriptionTxt">{{ 'CONFIRMATION.DESCRIPTION' | translate }}</mat-label>
              <textarea maxLength="100" matInput formControlName="descriptionTxt" cdkTextareaAutosize cdkAutosizeMaxRows="5"></textarea>
            </mat-form-field>
          </div>

          <div
            fxLayout="row wrap"
            fxLayoutGap="5px"
            fxLayoutAlign="space-between center"
            *ngIf="
              isPendingStatus() &&
                (ability.includes(PORTAL_AUTHORITY_ENUM.PERM_APPROVE_SALE_DATA) ||
                  ability.includes(PORTAL_AUTHORITY_ENUM.PERM_REQUEST_MODIFICATION_SALE_DATA));
              else templateConfirmBtn
            "
            class="w-100-p"
          >
            <button
              mat-raised-button
              class="artstuff-orange-fg mb-16"
              *aclHasPermission="[PORTAL_AUTHORITY_ENUM.PERM_REQUEST_MODIFICATION_SALE_DATA]"
              (click)="onRequestModification()"
            >
              {{ 'CONFIRMATION.REQUEST_MODIFICATION' | translate | uppercase }}
            </button>
            <button
              mat-raised-button
              color="accent"
              class="artstuff-dialog-button mb-16"
              *aclHasPermission="[PORTAL_AUTHORITY_ENUM.PERM_APPROVE_SALE_DATA]"
              (click)="onApprove()"
            >
              {{ 'CONFIRMATION.APPROVE' | translate | uppercase }}
            </button>
          </div>
          <ng-template #templateConfirmBtn>
            <button
              *ngIf="
                ability.includes(PORTAL_AUTHORITY_ENUM.PERM_CONFIRM_SALE_DATA) &&
                !(
                  reconciledDetail.status === TICKET_STATUS_ENUM.COMPLETED || reconciledDetail.status === TICKET_STATUS_ENUM.WAITINGAPPROVAL
                )
              "
              color="accent"
              class="artstuff-dialog-button mb-16"
              mat-raised-button
              [disabled]="!confirmationForm.get('selectReason').value"
              (click)="onConfirmReason()"
            >
              {{ 'CONFIRMATION.CONFIRM' | translate | uppercase }}
            </button>
          </ng-template>
        </div>
      </div>
      <div class="comments-section my-16" fxLayout="column" fxLayoutAlign="start start">
        <!-- Header -->
        <div class="comments-section__header h-56 pl-24 text-bold artstuff-orange-fg w-100-p" fxLayout="row" fxLayoutAlign="start center">
          {{ 'COMMENT.TITLE' | translate }} {{ reconciledDetail.comments.length == 0 ? '' : '(' + reconciledDetail.comments.length + ')' }}
        </div>
        <!-- Detail -->
        <div class="comments-section__detail w-100-p px-16 pb-32">
          <app-simple-comment
            [comments]="reconciledDetail.comments"
            (newCommentEvent)="addNewComment($event)"
            [disable]="
              isMakerViewMode() ||
              isCheckerMode() ||
              !ability.includes(PORTAL_AUTHORITY_ENUM.PERM_COMMENT_SALE_DATA) ||
              reconciledDetail.reconcileStatus === RECONCILE_STATUS_ENUM.RECONCILED
            "
          ></app-simple-comment>
        </div>
      </div>
    </div>
  </div>
</div>
